export const getExportText = (t, language, key, ar, en) =>
  t(key, language === "en" ? en : ar);
